<section class="banner">
    <div class="banner-half"></div>

    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h1>THE <span>ULTIMATE</span> INVENTORY 
                    MANAGEMENT AND B2B
                    PORTAL FOR BUSINESSES.</h1>

                <a routerLink="/login">Get Started, It’s Free!</a>
            </div>
            <div class="col-md-6">
                <img src="/assets/img/banner1.png" alt="banner" class="w-100">
            </div>
        </div>
    </div>
</section>

<!-- info -->

<section class="about-clock">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="home-title">What is Clockwork?</h2>
                <p>   Clockwork is a business to business e-commerce and inventory
                    management platform designed for automotive aftermarket wheel
                           companies. Clockwork brings together multiple supplier’s
                    catalogues under one platform for resellers to check inventory and
                    place orders, without the need to call, email or text and wait for an 
                                                          update to close the sale.</p>
            </div>
        </div>
    </div>
</section>

<!-- home -logo -->
<section class="home-logos d-none">
    <h2 class="home-title text-center">Industry Leading Brands Sell Through Clockwork.</h2>
    <div class="home-logos-wrap">
        <div class="new-home-logo">
            <a href="#">
                <img src="/assets/img/new-b-1.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-2.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-3.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-4.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-5.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-6.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-7.png"/>
            </a>

        </div>
    </div>
    
</section>

<!-- dashboard -->
<section class="dashboard-text-wrap" id="supplierfeature">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <span class="new-chip">Features</span>
                <h3 class="dashboard-title">Dashboard</h3> 
                <div class="info-ul">
                    <h4>Deep Insights.</h4>
                    <ul>
                        <li>A detailed look into the highest performing retailers, team members and products.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <h4>Unlimited User Support.</h4>
                    <ul>
                        <li>Assign roles to as many team
                            members as required.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <h4>Complete Control From Your Supplier
                        Dashboard. </h4>
                    <ul>
                        <li>Manage product data, Inventory, add warehouses, process orders, setup new dealers and much more.</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-lg-8">
                <img src="/assets/img/dashboard.png" class="w-100"/>
            </div>
        </div>
    </div>
</section>

<!-- data managment -->
<section class="dashboard-text-wrap">
    <div class="container">
        <div class="row">
            
            <div class="col-md-6 col-lg-8 order-2 order-md-1">
                <img src="/assets/img/data-managment.png" class="w-100"/>
            </div>
            <div class="col-md-6 col-lg-4 order-md-2">
                <span class="new-chip">Features</span>
                <h3 class="dashboard-title">Data Management</h3> 
                <div class="info-ul">
                    <h4>Data Simplified.</h4>
                    <ul>
                        <li>Bulk upload or download your entire product catalogue, change pricing or update SKU's in seconds with our excel-like interface.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <h4>Securely Hosted on Cloud.</h4>
                    <ul>
                        <li>Product data and images securely stored and accessible 24/7 without any storage fees.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- inventory -->
<section class="dashboard-text-wrap">
    <div class="container">
        <div class="row">
            
            
            <div class="col-md-6 col-lg-4">
                <span class="new-chip">Features</span>
                <h3 class="dashboard-title">Inventory</h3> 
                <div class="info-ul">
                    <h4>Inventory managed right.</h4>
                    <ul>
                        <li>Stock counts automatically adjusted with every new or cancelled order. Miscounts easily rectified. Just like in Excel. Add estimated arrival dates for new inventory.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <h4>Transparency.</h4>
                    <ul>
                        <li>Allow retailers to see exactly how much stock is available and when new stock is expected to arrive. Allowing them to act faster when limited quantities are available.</li>
                    </ul>
                </div>
            </div>

            <div class="col-md-6 col-lg-8">
                <img src="/assets/img/inventory-new.png" class="w-100"/>
            </div>
        </div>
    </div>
</section>


<!-- Warehouses -->
<section class="dashboard-text-wrap fourth">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-8 order-2 order-md-1">
                <img src="/assets/img/warehouse-new.png" class="w-100"/>
            </div>
            <div class="col-md-6 col-lg-4 order-md-2">
                <span class="new-chip">Features</span>
                <h3 class="dashboard-title">Warehouses</h3> 
                <div class="info-ul">
                    <h4>Multiple Warehouse Support.</h4>
                    <ul>
                        <li>Add as many warehouses and the exact stock count available in each warehouse. Retailers can choose the closest warehouse location to order parts from on the dealer portal. Saving on transit times and transportation costs.</li>
                    </ul>
                </div>
            </div>
            
        </div>
    </div>
</section>


<!-- Dealers -->
<section class="dashboard-text-wrap">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <span class="new-chip">Features</span>
                <h3 class="dashboard-title">Dealers</h3> 
                <div class="info-ul">
                    <h4>Dealer Discounts.</h4>
                    <ul>
                        <li>Setup wholesale discount levels for each individual retailer.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <h4>Managed Accounts.</h4>
                    <ul>
                        <li>Assign a sales representative to each and every approved dealer on the platform.</li>
                    </ul>
                </div>
                <div class="info-ul">
                    <div class="deta-box">
                        <h4>Dealer Data</h4>
                        <span>Coming Soon</span>
                    </div>
                    <ul>
                        <li>Understand each customers lifetime value, most ordered products, sales cycles, demand by geographic area, abandoned carts history and more.</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-lg-8">
                <img src="/assets/img/dealers.png" class="w-100"/>
            </div>
        </div>
    </div>
</section>


<!-- Dealers -->
<section class="dashboard-text-wrap portal-wrap">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <h3 class="dashboard-title">The Dealer Portal</h3> 
                <span>Invite only access to wholesale discounts.</span>
                <div class="info-ul">
                    <ul>
                        <li>24/7 Access to live inventory from multiple approved suppliers.</li>
                        <li>Order parts from suppliers at the agreed wholesale discount level.</li>
                        <li>Download supplier product data sheets and images.</li>
                        <li>Order history and invoices centralized for all suppliers.</li>
                        <li>Integrate a live inventory feed through the Clockwork API.</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-lg-8">
                <img src="/assets/img/portal-new.png" class="w-100"/>
            </div>
        </div>
    </div>
</section>


<section class="getstarted-wrap">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <p>Best of all it's free! No subscriptions for suppliers just sign up <br/> and let your business run like clockwork.</p>
                <a routerLink="/login">Get Started Free</a>
            </div>
        </div>
    </div>
</section>